import Vue from 'vue'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css'//引用element css组件
import ElementUI from 'element-ui'//引用element 组件
import 'animate.css'//引用animate.css
import i18n from './lang/index'//引用18n
import router from './router'//引入路由
import store from './store'//引入vuex
import 'swiper/swiper-bundle.css';


Vue.config.productionTip = false
Vue.use(ElementUI);//挂在ElementUI

new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
}).$mount('#app')
